export const messages = {
  en: {
    feePrintSpec: {
      title: 'Print Configuration',
      addTitle: 'Add Print Config',
      editTitle: 'Edit Print Config',
      deleteTitle: 'Delete Confirmation',
      deleteContent: 'Are you sure to delete this print config?',
      printId: 'Code',
      printName: 'Name',
      specCd: 'Specification',
      content: 'Content',
      qrImg: 'Image',
      operation: 'Operation',
      addBtn: 'Add',
      editBtn: 'Edit',
      deleteBtn: 'Delete',
      cancelBtn: 'Cancel',
      confirmBtn: 'Confirm',
      saveSuccess: 'Save successfully',
      updateSuccess: 'Update successfully',
      deleteSuccess: 'Delete successfully',
      spec1010: 'Payment Reminder',
      spec2020: 'Receipt Print'
    }
  },
  zh: {
    feePrintSpec: {
      title: '打印配置',
      addTitle: '添加打印配置',
      editTitle: '修改打印配置',
      deleteTitle: '删除确认',
      deleteContent: '确定删除该打印配置？',
      printId: '编码',
      printName: '名称',
      specCd: '规格',
      content: '内容',
      qrImg: '图片',
      operation: '操作',
      addBtn: '添加',
      editBtn: '修改',
      deleteBtn: '删除',
      cancelBtn: '取消',
      confirmBtn: '确认',
      saveSuccess: '保存成功',
      updateSuccess: '修改成功',
      deleteSuccess: '删除成功',
      spec1010: '催缴打印说明',
      spec2020: '收据打印'
    }
  }
}